import { Flex } from "antd"
import { Button, Icon, ModifiedDrawer, RadioButtons, Title } from "components/common"
import AppLink from "components/common/layout/app-link"
import { APPSTORE_URL, PLAYSTORE_URL } from "constants/appLinks"
import { ABOUT_US_PATH, CONTACT_US_PATH, FAQ_PATH, HOME_PATH, TERMS_PATH } from "constants/app-paths"
import { getAppLanguage, useLanguage } from "hooks/useLanguage"
import { forwardRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { openAppropriateStore } from "utils/appStore"
import { languageOptions } from "../../constants"
import styles from "./index.module.less"

import {
  BayutAppStoreArabicIcon,
  BayutAppStoreIcon,
  BayutPlayStoreArabicIcon,
  PlayStoreBadgeIcon,
} from "components/svg"

const MobileNavbar = forwardRef((props, ref) => {
  const { t } = useTranslation()
  const { changeAppLanguage } = useLanguage()
  const currentLang = getAppLanguage()
  const [selectedLanguage, setSelectedLanguage] = useState(currentLang?.locale)
  return (
    <ModifiedDrawer
      ref={ref}
      onClose={() => {
        ref?.current?.setVisible(false)
      }}
      hideCancelButton={true}
      onDestroyClose
      forceRender
      className={styles.sideDrawer}
      title={
        <div>
          {/* //hiding settings icons for now */}
          <div className="mbe-32" style={{ visibility: "hidden" }}>
            <Icon icon="IoSettingsSharp" className="text-primary" />
          </div>
          <Title level={2} className="mbe-16" titleFontSize="16px">
            {t("Change Site Settings")}
          </Title>
          <RadioButtons
            className={styles.radioChip}
            color="#c00"
            type="secondary-filled"
            value={selectedLanguage}
            onChange={e => {
              setSelectedLanguage(e?.target?.value)
              changeAppLanguage(e.target.value)
            }}
            options={languageOptions()}
          />
          {/* <Radio.Group className="w-100 d-flex" style={{ gap: "8px" }} shape="round">
            <RadioPill
              color="#28b16d"
              shape="round"
              className="w-100  justify-content-center"
              style={{ height: "40px" }}
            >
              abc
            </RadioPill>
          </Radio.Group> */}
        </div>
      }
      width={"70%"}
      height={"100%"}
      footer={null}
      placement={currentLang?.rtl ? "right" : "left"}
      style={{ "--ant-padding-lg": "16px" }}
      // headerStyle={{ "--ant-line-width": 0 }}
    >
      <Flex vertical gap={8}>
        <Button
          size="small"
          type="secondary-filled"
          text={t("Download App")}
          className="mbe-4"
          onClick={openAppropriateStore}
        />
        <Flex vertical gap={0} className={styles.navLinks}>
          <Link to={HOME_PATH} onClick={() => ref?.current?.setVisible(false)}>
            {t("Home")}
          </Link>

          <Link to={ABOUT_US_PATH} onClick={() => ref?.current?.setVisible(false)}>
            {t("About Us")}
          </Link>

          <Link to={CONTACT_US_PATH} onClick={() => ref?.current?.setVisible(false)}>
            {t("Contact Us")}
          </Link>

          <Link to={FAQ_PATH} onClick={() => ref?.current?.setVisible(false)}>
            {t("faqs_title")}
          </Link>

          <Link to={TERMS_PATH} onClick={() => ref?.current?.setVisible(false)}>
            {t("Terms & Conditions")}
          </Link>
        </Flex>

        <div className={styles.downloadApp} style={{ marginInline: "-16px", paddingInline: "16px" }}>
          <Title level={3}>{t("Download the Bayut App")}</Title>
          <Flex className=" mbe-40" align="center" gap="4px">
            <AppLink
              link={APPSTORE_URL}
              target={"_blank"}
              IconEn={BayutAppStoreIcon}
              IconAr={BayutAppStoreArabicIcon}
              width="110"
              height="34.8"
            />
            <AppLink
              link={PLAYSTORE_URL}
              target={"_blank"}
              IconEn={PlayStoreBadgeIcon}
              IconAr={BayutPlayStoreArabicIcon}
              height="34.8"
            />
          </Flex>
        </div>
      </Flex>
    </ModifiedDrawer>
  )
})

export default MobileNavbar
